<template>
  <el-checkbox-group class="exam-com-checkbox" disabled v-model="checkList">
    <el-checkbox
      v-for="(item, index) of list"
      :key="`${index}_${item.text}`"
      :label="index"
      :class="[
        quesAnswerMap[index]
          ? checkList.includes(index)
            ? 'success'
            : ''
          : 'error'
      ]"
    >
      {{ index | indexChat }}{{ item.text }}
    </el-checkbox>
  </el-checkbox-group>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => []
    },
    answer: {
      type: Array,
      default: () => []
    },
    quesAnswer: {
      type: Array,
      default: () => []
    },
    onInput: {
      type: Function,
      default: () => {}
    }
  },
  filters: {
    indexChat(index) {
      return `${String.fromCharCode(index + 65)}) `
    }
  },
  data() {
    return {
      checkList: []
    }
  },
  computed: {
    quesAnswerMap() {
      return this.quesAnswer.reduce((map, id) => ({ ...map, [id]: true }), {})
    }
  },
  watch: {
    answer: {
      immediate: true,
      handler() {
        this.checkList = this.answer.map(Number)
      }
    },
    checkList() {
      this.onInput(this.checkList)
    }
  }
}
</script>

<style scoped lang="scss">
.exam-com-checkbox {
  ::v-deep .el-checkbox {
    width: 100%;
    margin: 8px 0;
    &:hover {
      background-color: #fff781;
    }
    .el-checkbox__label {
      display: inline-block;
      white-space: normal;
      word-break: break-word;
      vertical-align: text-top;
      width: 90%;
    }
    &.is-checked,
    &:active,
    &:focus {
      background-color: #fff781;
      .el-checkbox__inner {
        background-color: #fff;
        border-color: #3b86ff;
        color: #3b86ff;
        border-width: 2px;
        &:after {
          border-color: #3b86ff;
          border-width: 2px;
          left: 3px;
          top: 0px;
        }
      }
      .el-checkbox__label {
        color: #606266;
      }
    }
    &.success {
      .el-checkbox__label {
        color: #36c626;
      }
    }
    &.error {
      .el-checkbox__label {
        color: #ff1a2e;
      }
    }
  }
}
</style>
